import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getStockLedger = createAsyncThunk(
  "stockLedger/getStockLedger",
  async (body, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(API_URL.STOCK_LEDGER.LEDGER, body);
      return data;
    } catch (error) {
      // axios response interceptor rejects with error.response, so the API
      // body lives at error.data. Pass it through so validationErrorNotification
      // can read its `isSuccess` / `message` fields and surface a toast.
      return rejectWithValue(error?.data || error?.message);
    }
  },
);

const initialState = {
  ledger_data: null,
  ledger_loading: false,
  ledger_error: null,
};

const stockLedgerSlice = createSlice({
  name: "stockLedger",
  initialState,
  reducers: {
    resetStockLedger: (state) => {
      state.ledger_data = null;
      state.ledger_loading = false;
      state.ledger_error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStockLedger.pending, (state) => {
        state.ledger_loading = true;
        state.ledger_error = null;
      })
      .addCase(getStockLedger.fulfilled, (state, action) => {
        state.ledger_loading = false;
        state.ledger_data = action.payload?.data || null;
      })
      .addCase(getStockLedger.rejected, (state, action) => {
        state.ledger_loading = false;
        state.ledger_error = action.payload;
      });
  },
});

export const { resetStockLedger } = stockLedgerSlice.actions;
export default stockLedgerSlice.reducer;
